import { LoadingTypography } from '@modules/common/components/LoadingTypography';
import { formatNumToStandardNotation } from '@modules/common/utils';
import { FeedbackSummaryGlobalToggle } from '@modules/feedback/components/FeedbackList/FeedbackSummaryGlobalToggle';
import { Box, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface FeedbackListHeaderProps {
  secondaryActionNode?: ReactNode;
  isSummaryView: boolean;
  onSummaryViewChange: (isSummaryView: boolean) => void;
  feedbackCount: number | undefined;
  isFetchingFeedbackCount: boolean;
}

export function FeedbackListHeader({
  isSummaryView,
  onSummaryViewChange,
  secondaryActionNode,
  feedbackCount,
  isFetchingFeedbackCount,
}: FeedbackListHeaderProps) {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
    >
      <Typography
        variant="h6"
        component={Stack}
        direction="row"
        alignItems="flex-start"
      >
        <Box>Feedback Records</Box>
        {(isFetchingFeedbackCount || feedbackCount !== undefined) && (
          <Box>
            <LoadingTypography
              isLoading={isFetchingFeedbackCount}
              variant="inherit"
              sx={{ minWidth: '20px', m: 'auto', ml: 0.5 }}
            >
              : {formatNumToStandardNotation(feedbackCount ?? 0)}
            </LoadingTypography>{' '}
          </Box>
        )}
      </Typography>
      <Stack direction="row" spacing={2}>
        {secondaryActionNode}
        <FeedbackSummaryGlobalToggle
          isSummaryView={isSummaryView}
          onChange={onSummaryViewChange}
          showShrinkedButton={true}
          isDrawer
        />
      </Stack>
    </Stack>
  );
}
